import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from "@angular/core";
import { Guia } from "../../../../models/Guia";

@Component({
  selector: "app-aba-leitor",
  templateUrl: "./aba-leitor.component.html",
  styleUrls: ["./aba-leitor.component.scss"],
})
export class AbaLeitorComponent {
  @Input()
  public guia: Guia;

  @Output()
  public fecharAba = new EventEmitter<string>();

  @Output()
  public alternarAba = new EventEmitter<string>();

  constructor(private changeDetector: ChangeDetectorRef) {}

  public alternarPara(e: Event) {
    e.preventDefault();
    e.stopPropagation();

    this.alternarAba.emit(this.guia.id);
    this.changeDetector.markForCheck();
  }

  public fecharGuia(e: Event) {
    e.preventDefault();
    e.stopPropagation();

    this.fecharAba.emit(this.guia.id);
  }
}
